import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './Emmanuel_Akinroye_Senior_Fullstack_Backend_Engineer_CV_UPDATED.pdf';
import { scrollContext } from "../../scrollctx/ctx";
import { useEffect } from "react";
import { useRef } from "react";

import { FaDesktop, FaServer, FaCubes } from "react-icons/fa";

const Services = () => {
  // ref
  const servicesRef = useRef();
  // context
  const {setServicesPos} = useContext(scrollContext)
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };
useEffect(()=>{
  setServicesPos(servicesRef.current.offsetTop);
},[])
  return (
    <div ref={servicesRef} className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <span>
          I am a fullstack developer experienced with JavaScript, and it various frontend frameworks.
          <br />
          I am also well experienced with blockchain development and <br /> I have built various web apps on eutherium and solana blockchain.
        </span>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            icon={<FaDesktop color="#FCA61F" />}
            heading={"FRONTEND"}
            detail={"HTML, CSS, REACTJS, TAILWIND CSS, CHAKRA-UI, BOOTSTRAP"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            icon={<FaServer color="#FCA61F" />}
            heading={"BACKEND"}
            detail={"NODEJS, NEXTJS, EXPRESSJS, MONGODB, MICROSERVICES"}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            icon={<FaCubes color="#FCA61F" />}
            heading={"BLOCKCHAIN"}
            detail={
              "JAVASCRIPT, RUST, SOLIDITY"
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
